import React from "react";
import { Deposit } from "../../../../../types/bookings";
import { StickyNote } from "lucide-react";
import { WebViewPopover } from "../../SubHeader/WebViewPopover";
import { EDSButton } from "../../../../eds/EDSButton";

type SelectedBookingPaymentNoteType = {
  deposit: Deposit;
};

export const SelectedBookingPaymentNote = ({
  deposit
}: SelectedBookingPaymentNoteType) => {
  const note = deposit.notes;

  if (!note) {
    return null;
  }

  return (
    <div className="PaymentNote w-9">
      <WebViewPopover
        side="bottom"
        content={
          <div className="PaymentNote-Container p-3 bg-background border border-border rounded-lg">
            <div className="PaymentNote-Header font-semibold text-sm mb-1">
              Notes
            </div>
            <div className="PaymentNote-Content text-sm text-muted-foreground">
              {note}
            </div>
          </div>
        }
      >
        <EDSButton size="icon" variant="outline">
          <StickyNote className="w-4 h-4" />
        </EDSButton>
      </WebViewPopover>
    </div>
  );
};
